export const normalizeString = (str) => {
  if (typeof str !== "string") return "";
  return str.toLowerCase().replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, " ").trim();
};

/**
 * Converts a search query into a Supabase full-text search string.
 * Splits on whitespace, sanitizes special chars, joins with " | ".
 */
export const normalizeAndSanitizeFTS = (input) => {
  return input
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .map((word) => word.replace(/[()&|!:']/g, ""))
    .filter(Boolean)
    .join(" | ");
};
